import * as api from '../../api';

const createNewPasswordActions = api.fetchActions('acct', 'create-new-password');

export const actionTypes = {
  ...createNewPasswordActions.actionTypes,
};

export const createNewPassword = (currentPassword, newPassword) =>
  api.postThunk('/sessions/ChangePassword', {currentPassword, newPassword}, createNewPasswordActions);


// WEBPACK FOOTER //
// src/acct/password/change-password.actions.js